import { sendPost } from '../http.js'
const api = {
	'problemCreate': {
        url: '/problem/create'
    },
    'problemList': {
        url: '/problem/list'
    },
    'problemDetail': {
        url: '/problem/detail'
    },
    'problemUpdate': {
        url: '/problem/update'
    },
    'problemDel': {
        url: '/problem/del'
    },
    'problemCategory': {
        url: '/problem/category'
    },
    'examCustom': {
        url: '/problem/exam/custom'
    },
    'examAdd': {
        url: '/problem/exam/add'
    },
    'examIndex': {
        url: '/problem/exam/index'
    },
    'examDetail':{
        url: '/problem/exam/detail'
    },
    'examEdit': {
        url: '/problem/exam/edit'
    },
    'examEnable': {
        url: '/problem/exam/enable'
    },
    'problemImportIndex': {
        url: '/problem/import/index'
    },
    'problemStatus': {
        url: '/problem/status'
    },
    'problemExamSync': {
        url: '/problem/exam/sync'
    },
    'problemExamDel': {
        url: '/problem/exam/del'
    },
    problemBatchDel: {
        url: '/problem/batch/del'
    }

}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params, method='post', headers) => {
            return sendPost(api[key].url, params, method, headers)
        }
    } 
}
export default requestFunObj
